module.exports = PhotoSwipe;